import { useAuth0 } from '@auth0/auth0-react';
import axios, { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import configuration from '../../configuration';

interface ArchivePollingRequest {
    pollId: number;
}

export function useArchivePolling(
    options?: Omit<
        UseMutationOptions<
            void,
            AxiosError,
            ArchivePollingRequest
        >,
        'mutationKey' | 'mutationFn'
    >,
) {
    const { getAccessTokenSilently } = useAuth0();
    return useMutation(
        async (req: ArchivePollingRequest) => {            
            const token = await getAccessTokenSilently();
            axios.post(`${configuration.apiUrl}/polls/polls/${req.pollId}/archive`, null, {
                headers: {
                    'authorization': `bearer ${token}`
                }
            });

        }, options
    );
}